import React from 'react';
import MUITable, {
  TableBody,
  TableCell,
  TableFooter,
  TablePagination,
  TableRow,
} from 'material-ui-next/Table';
import {
  TablePaginationActions,
  EnhancedTableHead
} from '../../widgets/table_utils.react.js';
import Checkbox from 'material-ui-next/Checkbox';
import {
  Redirect
} from 'react-router-dom'
import Chip from 'material-ui-next/Chip';
import CSSModules from 'react-css-modules';
import styles from './all.css';

class ClientTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect: null,
      data: props.data,
      order: 'desc',
      orderBy: 'create_at',
      selected: [],
      page: 0,
      new_page: 0,
      rowsPerPage: 10,
      rowCount: 0,
      enableSelect: false,
      loading: false
    }


    this.on_load_data = this.on_load_data.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.refresh = this.refresh.bind(this)

    this.handleRequestSort = this.handleRequestSort.bind(this)
    this.handleSelectAllClick = this.handleSelectAllClick.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleChangePage = this.handleChangePage.bind(this)
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
    this.isSelected = this.isSelected.bind(this)
    this.sortData = this.sortData.bind(this)

    this.get_column_configs = this.get_column_configs.bind(this)
  }

  get_column_configs(return_dict) {
    const columnConfigs = [
      {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Client Name (First and Last Name)',
        data: (raw) => {
          return raw.name
        }
      },
      {
        id: 'email',
        numeric: false,
        disablePadding: false,
        label: 'Client Email',
        data: (raw) => {
          return raw.user.username
        }
      },
      {
        id: 'create_at',
        numeric: false,
        disablePadding: false,
        label: 'Registered At',
        data: (raw) => {
          return raw.created_at
        }
      },
      {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'Actions',
        disableSort: true
      }
    ]

    if (return_dict) {
      return columnConfigs.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})
    }

    return columnConfigs
  }

  sortData(data, order, orderBy) {
    var self = this;

    const _data =
      order === 'desc' ?
      data.sort(
        (a, b) => {
          var va = a[orderBy]
          var vb = b[orderBy]
          const get_data = self.get_column_configs(true)[orderBy].data
          if (get_data) {
            va = get_data(a)
            vb = get_data(b)
          }
          return (vb < va) ? -1 : 1
        }
      ) :
      data.sort(
        (a, b) => {
          var va = a[orderBy]
          var vb = b[orderBy]
          const get_data = self.get_column_configs(true)[orderBy].data
          if (get_data) {
            va = get_data(a)
            vb = get_data(b)
          }
          return (va < vb) ? -1 : 1
        }
      );

    this.setState({
      _data,
      order,
      orderBy,
      loading: false
    });
  }

  handleRequestSort(event, property) {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.sortData(this.state.data, order, orderBy)
  }

  handleSelectAllClick(event, checked) {
    if (checked) {
      this.setState({
        selected: this.state.data.map(n => n.id)
      });
      return;
    }
    this.setState({
      selected: []
    });
  }

  handleClick(event, id) {
    const {
      selected
    } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({
      selected: newSelected
    })
  }

  handleChangePage(event, page) {
    this.setState({
      new_page: page
    }, () => {
      this.refresh(
        page * this.state.rowsPerPage
      )
    });
  }

  handleChangeRowsPerPage(event) {
    this.setState({
      rowsPerPage: event.target.value
    }, () => {
      this.refresh(
        this.state.new_page * this.state.rowsPerPage,
        this.state.rowsPerPage
      )
    });
  }

  isSelected(id) {
    return this.state.selected.indexOf(id) !== -1
  }

  on_load_data(all_clients) {
    this.setState({
      data: all_clients.results,
      rowCount: all_clients.count,
      page: this.state.new_page
    }, () => {
      this.sortData(this.state.data, this.state.order, this.state.orderBy)
    })
  }

  componentWillMount() {
    this.refresh()
  }

  handleClickEdit(data) {
    var self = this;
    return (e) => {
      self.props.open_edit(data)
    }
  }

  handleDelete(data) {
    var self = this;
    return (e) => {
      self.props.delete_client(
        data, (err) => {
          if (!err) {
            this.props.load_clients(this.on_load_data)
          }
        }
      )
    }
  }

  refresh(offset, rowsPerPage) {
    this.setState(
      {loading: true}, () => {
        this.props.load_clients(
          rowsPerPage || this.state.rowsPerPage,
          offset || this.state.new_page * this.state.rowsPerPage,
          this.on_load_data
        )
      }
    )
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={{pathname: this.state.redirect}} />
    }
    const columnConfigs = this.get_column_configs()
    const {
      data,
      loading,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      rowCount,
      enableSelect
    } = this.state;
    const emptyRows = rowsPerPage - Math.min(
      rowsPerPage, data.length - page * rowsPerPage);

    return (
      <MUITable styleName="cli-table">
        <EnhancedTableHead
          loading={loading}
          numSelected={selected.length}
          onRequestSort={this.handleRequestSort}
          onSelectAllClick={this.handleSelectAllClick}
          order={order}
          orderBy={orderBy}
          rowCount={data.length}
          columnConfigs={columnConfigs}
        >
        </EnhancedTableHead>
        <TableBody>
          {
            this.state.data.map((info) => {
              const user = info.user
              const isSelected = this.isSelected(info.id);
              return (
                <TableRow
                  key={info.id}
                  aria-checked={isSelected}
                  selected={isSelected}
                  onClick={(event) => {this.handleClick(event, info.id)}}
                  >
                  {enableSelect && (
                     <TableCell padding="checkbox">
                       <Checkbox checked={isSelected} />
                     </TableCell>
                  )}
                  <TableCell>{info.name}</TableCell>
                  <TableCell>{user.username}</TableCell>
                  <TableCell>{info.created_at}</TableCell>
                  <TableCell>
                    <Chip label="Edit" onClick={this.handleClickEdit(info)} />
                  </TableCell>
                </TableRow>
              )
            })
          }
          {emptyRows > 0 && (
             <TableRow>
               <TableCell colSpan={6} />
             </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={4}
              count={rowCount}
              rowsPerPageOptions={[10, 25, 50]}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
              Actions={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </MUITable>
    )
  }
}

ClientTable.defaultProps = {
  data: [],
  load_clients: null,
  delete_client: null,
  open_edit: null
}

export default CSSModules(ClientTable, styles)



// WEBPACK FOOTER //
// ./src/views/clients/client_table.react.js